<template>
  <v-layout>
    <v-card style="width: 100%;">
      <v-card-text>
        <v-container
        fluid
        grid-list-lg
        >
        <v-layout row wrap>
            <div class="scroll-here">
              <v-flex xs12>
                <strong>New Evals</strong>
              </v-flex>
              <v-flex v-for="newEval in newEvals" :key="newEval.id" xs12>
                <v-card class="elevation-4">
                  <v-card-text v-if="newEval.year < 2025">
                    <v-layout wrap>
                      <v-flex xs4 md2>
                        {{ newEval.year }}
                      </v-flex>
                      <v-flex xs8 md10>
                        <strong>{{ newEval.name }}</strong>
                      </v-flex>
                      <v-flex xs4 md2></v-flex>
                      <v-flex xs8 md10>
                        <v-layout wrap>
                          <v-flex xs3>
                            Hours: {{ newEval.hours }}
                          </v-flex>
                          <v-flex xs3>
                            Award:
                            <span v-if="newEval.award === 1">
                              Yes
                            </span>
                            <span v-else>
                              No
                            </span>
                          </v-flex>
                          <v-flex xs3>
                            Drop:
                            <span v-if="newEval.drop === 1">
                              Yes
                            </span>
                            <span v-else>
                              No
                            </span>
                          </v-flex>
                          <v-flex xs3>
                            Excused:
                            <span v-if="newEval.excussed === 1">
                              Yes
                            </span>
                            <span v-else>
                              No
                            </span>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs4 md2></v-flex>
                      <v-flex xs8 md10>
                        <v-layout wrap>
                          <v-flex xs12>
                            Notes:
                          </v-flex>
                          <v-flex xs1></v-flex>
                          <v-flex xs11>
                            Award: {{ newEval.awardNotes }}
                          </v-flex>
                          <v-flex xs1></v-flex>
                          <v-flex xs11>
                            Drop: {{ newEval.dropNotes }}
                          </v-flex>
                          <v-flex xs1></v-flex>
                          <v-flex xs11>
                            Excused: {{ newEval.exceussedNotes }}
                          </v-flex>
                          <v-flex xs1></v-flex>
                          <v-flex xs11>
                            Other: {{ newEval.notes }}
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-text v-else>
                    <v-layout wrap>
                      <v-flex xs4 md2>
                        {{ newEval.year }}
                      </v-flex>
                      <v-flex xs8 md10>
                        <strong>{{ newEval.name }}</strong>
                      </v-flex>
                      <v-flex xs4 md2></v-flex>
                      <v-flex xs8 md10>
                        <v-layout wrap>
                          <v-flex xs12 v-if="newEval.attitudeWork === 4"><b>1. Leadership:</b> Top Hand</v-flex>
                          <v-flex xs12 v-if="newEval.attitudeWork === 3"><b>1. Leadership:</b> Exceeds Expectations</v-flex>
                          <v-flex xs12 v-if="newEval.attitudeWork === 2"><b>1. Leadership:</b> Meets Expectations</v-flex>
                          <v-flex xs12 v-if="newEval.attitudeWork === 1"><b>1. Leadership:</b> Needs Improvement</v-flex>
                          <v-flex xs12 v-if="newEval.attitudeRodeo === 4"><b>2. Knowledge of Position/Committee:</b> Top Hand</v-flex>
                          <v-flex xs12 v-if="newEval.attitudeRodeo === 3"><b>2. Knowledge of Position/Committee:</b> Exceeds Expectations</v-flex>
                          <v-flex xs12 v-if="newEval.attitudeRodeo === 2"><b>2. Knowledge of Position/Committee:</b> Meets Expectations</v-flex>
                          <v-flex xs12 v-if="newEval.attitudeRodeo === 1"><b>2. Knowledge of Position/Committee:</b> Needs Improvement</v-flex>
                          <v-flex xs12 v-if="newEval.locGuests === 4"><b>3. Quality of Work:</b> Top Hand</v-flex>
                          <v-flex xs12 v-if="newEval.locGuests === 3"><b>3. Quality of Work:</b> Exceeds Expectations</v-flex>
                          <v-flex xs12 v-if="newEval.locGuests === 2"><b>3. Quality of Work:</b> Meets Expectations</v-flex>
                          <v-flex xs12 v-if="newEval.locGuests === 1"><b>3. Quality of Work:</b> Needs Improvement</v-flex>
                          <v-flex xs12 v-if="newEval.locCommembers === 4"><b>4. Dependability:</b> Top Hand</v-flex>
                          <v-flex xs12 v-if="newEval.locCommembers === 3"><b>4. Dependability:</b> Exceeds Expectations</v-flex>
                          <v-flex xs12 v-if="newEval.locCommembers === 2"><b>4. Dependability:</b> Meets Expectations</v-flex>
                          <v-flex xs12 v-if="newEval.locCommembers === 1"><b>4. Dependability:</b> Needs Improvement</v-flex>
                          <v-flex xs12 v-if="newEval.locComleaders === 4"><b>5. Interpersonal Relationship:</b> Top Hand</v-flex>
                          <v-flex xs12 v-if="newEval.locComleaders === 3"><b>5. Interpersonal Relationship:</b> Exceeds Expectations</v-flex>
                          <v-flex xs12 v-if="newEval.locComleaders === 2"><b>5. Interpersonal Relationship:</b> Meets Expectations</v-flex>
                          <v-flex xs12 v-if="newEval.locComleaders === 1"><b>5. Interpersonal Relationship:</b> Needs Improvement</v-flex>
                          <v-flex xs12 v-if="newEval.profOntime === 4"><b>6. Personal Qualities:</b> Top Hand</v-flex>
                          <v-flex xs12 v-if="newEval.profOntime === 3"><b>6. Personal Qualities:</b> Exceeds Expectations</v-flex>
                          <v-flex xs12 v-if="newEval.profOntime === 2"><b>6. Personal Qualities:</b> Meets Expectations</v-flex>
                          <v-flex xs12 v-if="newEval.profOntime === 1"><b>6. Personal Qualities:</b> Needs Improvement</v-flex>
                          <v-flex xs12><b>7. Comments:</b> {{ newEval.notes}}</v-flex>
                          <v-flex xs12></v-flex>
                          <v-flex xs3>
                            Hours: {{ newEval.hours }}
                          </v-flex>
                          <v-flex xs3>
                            Award:
                            <span v-if="newEval.award === 1">
                              <span v-if="newEval.awardType === 'Recognition Award - Reliable performance or positive behavior worth acknowledging'"> Yes - Recognition Award</span>
                              <span v-if="newEval.awardType === 'Exceptional Contribution Award - Went beyond assigned duties through initiative, leadership, extra time, or improvements'"> Yes - Exceptional Contribution Award</span>
                              <span v-if="newEval.awardType === 'Top Hand Award (Reserved for Best of the Best ) - Exceptional impact, inspiring performance AND leadership and significant positive contribution to the Association'"> Yes - Top Hand Award</span>
                            </span>
                            <span v-else>
                              No
                            </span>
                          </v-flex>
                          <v-flex xs3>
                            Drop:
                            <span v-if="newEval.drop === 1">
                              Yes
                            </span>
                            <span v-else>
                              No
                            </span>
                          </v-flex>
                          <v-flex xs3>
                            Excused:
                            <span v-if="newEval.excussed === 1">
                              Yes
                            </span>
                            <span v-else>
                              No
                            </span>
                          </v-flex>
                          <v-flex xs3>
                            <span v-if="newEval.noWork === 1">
                              <b>Did not work</b>
                            </span>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs4 md2></v-flex>
                      <v-flex xs8 md10>
                        <v-layout wrap>
                          <v-flex xs12>
                            Notes:
                          </v-flex>
                          <v-flex xs1></v-flex>
                          <v-flex xs11>
                            Award: {{ newEval.awardNotes }}
                          </v-flex>
                          <v-flex xs1></v-flex>
                          <v-flex xs11>
                            Drop: {{ newEval.dropNotes }}
                          </v-flex>
                          <v-flex xs1></v-flex>
                          <v-flex xs11>
                            Excused: {{ newEval.excussedNotes }}
                          </v-flex>
                          <v-flex xs1></v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12>
                <strong>Old Evals</strong>
              </v-flex>
              <v-flex v-for="oldEval in oldEvals" :key="oldEval.id" xs12>
                <v-card class="elevation-4">
                  <v-card-text>
                    <v-layout wrap>
                      <v-flex xs4 md2>
                        {{ oldEval.year }}
                      </v-flex>
                      <v-flex xs8 md10>
                        <strong>{{ oldEval.committee }}</strong>
                      </v-flex>
                      <v-flex xs4 md2></v-flex>
                      <v-flex xs8 md10>
                        <v-layout wrap>
                          <v-flex xs3>
                            Hours: {{ oldEval.hours }}
                          </v-flex>
                          <v-flex xs3>
                            Award:
                            <span v-if="oldEval.award === 'yes'">
                              Yes
                            </span>
                            <span v-else>
                              No
                            </span>
                          </v-flex>
                          <v-flex xs3>
                            Drop:
                            <span v-if="oldEval.drop ===  'yes'">
                              Yes
                            </span>
                            <span v-else>
                              No
                            </span>
                          </v-flex>
                          <v-flex xs3>
                            Evaluation: {{ oldEval.evaluation }}
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs4 md2></v-flex>
                      <v-flex xs8 md10>
                        <v-layout wrap>
                          <v-flex xs12>
                            Notes:
                          </v-flex>
                          <v-flex xs1></v-flex>
                          <v-flex xs11>
                            {{ oldEval.notes }}
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </div>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </v-layout>
</template>

<script>
export default {
  props: ['visible', 'newEvals', 'oldEvals'],

  data () {
    return {
    }
  }
}
</script>

<style>
.centered-input input {
  text-align: center;
}

.scroll-here {
  overflow: auto;
  height: 340px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/forms/EvalList.vue